import React from "react";
import * as _ from "lodash";

interface BcfCheckboxProps {
    name: string;
    onClick: (checked: boolean) => void;
}

export default class BcfCheckbox extends React.Component<BcfCheckboxProps> {

    state: { checked: boolean };
    private readonly name: string;

    constructor(props : BcfCheckboxProps) {
        super(props);

        this.state = { checked: false };
        this.setChecked = this.setChecked.bind(this);
        this.toggle = this.toggle.bind(this);

        this.name = this.props.name.length > 80
            ? this.props.name.substring(0, 77) + "..."
            : this.props.name;
    }

    private toggle(element: any) {
        this.setState({ checked: element.target.checked });
        this.props.onClick(element.target.checked);
    }

    render() {
        return <div className="custom-control custom-switch">
                   <input type="checkbox" className="custom-control-input" id="bcfGhosting"
                          checked={this.state.checked}
                          onChange={this.toggle} />
                   <label className="custom-control-label" htmlFor="bcfGhosting">{this.name}</label>
            </div>;
    }

    setChecked(checked: boolean) {
        this.setState({ checked: checked });
    }
}